import { AdvancedTooltip } from  "./advancedtooltip";
import { events } from "./events";
import { Popover, Tooltip } from "bootstrap";
import "jquery-touchswipe";
import "print-this";
import "bootstrap-datepicker";

const Plugins = () => {
    const returnObj = {};

    /**
     * @param {jQuery} $selector
     */
    returnObj.init = function ($selector) {

        $(document).ready(function () {
            if (!$selector) {
                $selector = $(document);
            } else if (!($selector instanceof $)) {
                $selector = $($selector);
            }

            $('[data-bs-toggle="tooltip"]', $selector).each(function(index, element) {
                Tooltip.getOrCreateInstance(element);
                element.style.cursor = 'pointer';
            });
            $('[data-bs-toggle="popover"]', $selector).each(function(index, element) {
                Popover.getOrCreateInstance(element);
                element.style.cursor = 'pointer';
            });

            AdvancedTooltip.init($selector);

            /** multi dropdown levels */
            $('.dropdown-menu > li > a[data-bs-toggle="dropdown"]', $selector).on('click', function (e) {
                var current = $(this).next();
                var grandparent = $(this).parent().parent();

                grandparent.find(".sub-menu:visible").not(current).hide();
                current.toggle();
                e.stopPropagation();
                return false;
            });

            $('.dropdown-menu > li > a:not(.trigger)', $selector).on('click', function () {
                var root = $(this).closest('.dropdown');
                root.find('.sub-menu:visible').hide();
            });


            // adding chevron on accordion
            $selector.off('shown.bs.collapse');
            $selector.on('shown.bs.collapse', function (e) {
                // @TODO check if the element is a collapsable tab
                var iconBot = '<span class="jq-halflings-triangle icon-pos-left halflings halflings-triangle-bottom"></span>';
                var iconTop = '<span class="jq-halflings-triangle icon-pos-left halflings halflings-triangle-top"></span>';
                $('.addedIcon-tab-responsive .panel-title a span').remove();
                $('.addedIcon-tab-responsive .panel-title a.collapsed').prepend(iconBot);

                $('.addedIcon-tab-responsive .panel-title a:not(.collapsed)').prepend(iconTop);
            });

            // remove chevron on accordion
            $selector.off('shown.bs.collapse');
            $selector.on('shown.bs.collapse', function () {
                // @TODO check if the element is a collapsable tab
                $('.addedIcon-tab-responsive .panel-title a span').remove();
            });

            returnObj.carouselClick();
            returnObj.carouselSwipe();

            // set the events to open a link in the iframe
            $('.jq-open-link-in-iframe', $selector).on('click', function (e) {
                if (e.target && e.target.nodeName && e.target.nodeName === 'A') {
                    return true;
                }
                e.preventDefault();
                var iframe = document.createElement('iframe');
                iframe.src = this.dataset.src;
                iframe.width = 'auto';
                iframe.height = 'auto';
                iframe.setAttribute('allowfullscreen', '');
                this.parentNode.replaceChild(iframe, this);
                return false;
            });
        });
    };

    /**
     * click event for all kinds of carousels
     */
    returnObj.carouselClick = function () {
        /**
         * stage carousel
         */
        $('.stage-carousel .carousel-inner').each(function (i, o) {
            $(o).click(function (e) {
                var $i = $(this).find('.carousel-item.active[data-setu-href]');

                if ($i.length === 1) {
                    e.preventDefault();
                    events.fireDataEvent('salesTeaser.click', [$i, e]);
                    window.open($i.attr('data-setu-href'), $i.attr('data-bs-target') === '_blank' ? '_blank' : '_self');
                }
            });
        });

        /**
         * sales teasers NOT in a product carousel
         */
        $('article[data-setu-href]').each(function (i, o) {
            if ($(o).closest('.product-carousel').length === 0) {
                $(o).click(function (e) {
                    e.preventDefault();
                    var $a = $(this), $l = $a.find('a[href]');
                    if ($l.length > 0) {
                        $l = $l.first();
                        e.preventDefault();
                        events.fireDataEvent('salesTeaser.click', [$a, e]);
                        window.open($l.attr('href'), $l.attr('target') === '_blank' ? '_blank' : '_self');
                    }
                });
            }
        });
    };

    /**
     * swipe function for all carousel components
     */
    returnObj.carouselSwipe = function (hash) {
        var hash = hash || '.carousel';
        $(hash).swipe({
            swipeLeft: function (event, direction, distance, duration, fingerCount) {
                $(this).carousel('next');
            },
            swipeRight: function (event, direction, distance, duration, fingerCount) {
                $(this).carousel('prev');
            }
        });
    };

    return returnObj;
}
export const plugins = Plugins();
